
import React, { Component } from "react";
import styled from "styled-components";
import TableCell from "@material-ui/core/TableCell";
import TextTruncate from "react-text-truncate";


const StyledTableCellComment = styled(TableCell)`
  font-size: 12px;
  color: #828282;
  min-width: 140px;
  vertical-align: top;
  word-break: break-all;
  max-width: 300px;
`;


export default class TableCellComment extends Component {
  render() {
    const { item } = this.props;
    return (
      <StyledTableCellComment>
        <TextTruncate text={item.description} line={4} />
      </StyledTableCellComment>
    )
  }
}
